import { Button, DatePicker, message, Select, Space, Spin } from "antd";
import gropicons from "assets/icons/group.png";
import reloadicon from "assets/icons/reload.png";
import { ContentTopBar } from "components";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import { DashboardApiService } from "features/dashboard/api/dashboard-api.service";
import { WalletGraph } from "features/dashboard/components/wallet-graph/Wallet-graph";
import { Fragment, useEffect, useState } from "react";

dayjs.extend(customParseFormat);
dayjs.extend(timezone);

export const DashBoardView = () => {
  const { RangePicker } = DatePicker;
  const currentDate = dayjs();

  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(
    null
  );
  const [selectedYear, setSelectedYear] = useState<number>(currentDate.year());
  const [selectedMonth, setSelectedMonth] = useState<string>(
    currentDate.format("MMM")
  );
  const [state, setState] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const isCustomDateRange = dateRange && dateRange[0] && dateRange[1];

  // Generate year options
  const years = [];
  for (let y = currentDate.year() - 10; y <= currentDate.year() + 5; y++) {
    years.push({ label: y.toString(), value: y });
  }

  // Month options (All + short month names)
  const monthOptions = [
    { label: "All Month", value: "All" },
    ...dayjs.monthsShort().map((m) => ({ label: m, value: m })),
  ];

  // Main API call
  const Initial = async () => {
    setLoading(true);
    try {
      // Date handling
      // const fromDate =
      //   dateRange && dateRange[0]
      //     ? dateRange[0].startOf("day").tz("Asia/Kolkata").format("YYYY-MM-DD")
      //     : "";
      // const toDate =
      //   dateRange && dateRange[1]
      //     ? dateRange[1].endOf("day").tz("Asia/Kolkata").format("YYYY-MM-DD")
      //     : "";
      const fromDate =
        dateRange && dateRange[0]
          ? dateRange[0].startOf("day").tz("Asia/Kolkata").format("YYYY-MM-DD")
          : "";
      const toDate =
        dateRange && dateRange[1]
          ? dateRange[1].endOf("day").tz("Asia/Kolkata").format("YYYY-MM-DD")
          : "";

      // ✅ Correct month number conversion (1–12)
      // const monthIndex = dayjs.monthsShort().indexOf(selectedMonth);
      // const monthNumber =
      //   selectedMonth === "All"
      //     ? ""
      //     : monthIndex !== -1
      //       ? monthIndex + 1
      //       : currentDate.month() + 1; // fallback to current month

      const monthIndex = dayjs.monthsShort().indexOf(selectedMonth);
      const monthNumber =
        selectedMonth === "All"
          ? ""
          : monthIndex !== -1
          ? monthIndex + 1
          : currentDate.month() + 1;

      const params = isCustomDateRange
        ? {
            from_date: fromDate,
            to_date: toDate,
          }
        : {
            year: selectedYear,
            month: monthNumber,
          };

      // const params = {
      //   year: selectedYear,
      //   month: monthNumber, // ✅ always numeric or empty
      //   start_date: fromDate,
      //   end_date: toDate,
      // };

      //     const apiRes = await DashboardApiService().getDashBoard(params as any);
      //     setState(apiRes);
      //   } catch (error: any) {
      //     message.error(error?.message || "Something went wrong");
      //   } finally {
      //     setLoading(false);
      //   }
      // };

      const apiRes = await DashboardApiService().getDashBoard(params as any);
      setState(apiRes);
    } catch (error: any) {
      message.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch when filters change
  useEffect(() => {
    if (selectedYear || dateRange) {
      Initial();
    }
  }, [selectedYear, selectedMonth, dateRange]);

  return (
    <Fragment>
      <ContentTopBar title={"Wallet Report"} />
      <Space direction="vertical" className="card_row">
        {/* Top Filter Section */}
        <Space style={{ marginBottom: 16 }} className="filter_srch">
          {/* Month Selector */}
          {/* <Select
            options={monthOptions}
            value={selectedMonth}
            style={{ width: 120 }}
            allowClear={true}
            placeholder="Select Month"
            onChange={(value) => {
              setSelectedMonth(value);
              setDateRange(null); // clear range when selecting month
            }}
          /> */}
          <Select
            options={monthOptions}
            value={selectedMonth || undefined}
            style={{ width: 120 }}
            allowClear={true}
            placeholder="Select Month"
            onChange={(value) => {
              setSelectedMonth(value || "");
              setDateRange(null); // clear date range if month selected
            }}
          />

          {/* Year Selector */}
          {/* <Select
            options={years}
            value={selectedYear}
            style={{ width: 120 }}
            allowClear={true}
            placeholder="Select Year"
            onChange={(value) => setSelectedYear(value)}
          /> */}
          <Select
            options={years}
            value={selectedYear}
            style={{ width: 120 }}
            allowClear={true}
            placeholder="Select Year"
            onChange={(value) => {
              setSelectedYear(value);
              setDateRange(null); // clear date range if year selected
            }}
          />

          {/* Date Range Picker */}
          <RangePicker
            value={dateRange}
            onChange={(dates) => {
              setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs]);
              if (dates && dates[0] && dates[1]) {
                setSelectedMonth(""); // hide month name
                setSelectedYear(null as any); // hide year
              } else {
                // optional: reset to current month/year if range cleared
                setSelectedMonth(currentDate.format("MMM"));
                setSelectedYear(currentDate.year());
              }
            }}
          />

          {/* Buttons */}
          <div className="filt_btn">
            <Button type="primary" onClick={Initial}>
              Filter
            </Button>
            <Button
              onClick={() => {
                const today = dayjs();
                setSelectedMonth(currentDate.format("MMM"));
                setSelectedYear(currentDate.year());
                setDateRange([today.startOf("day"), today.endOf("day")]);
              }}
            >
              Cancel
            </Button>
          </div>
        </Space>

        {/* Opening / Closing Balance Section */}
        <div className="op_cl">
          {state?.items?.map((item: any, index: number) => (
            <div key={index} className="op_cl_bx res_bx">
              <div className="card_wrap" style={{ backgroundColor: "#015B97" }}>
                <div className="card_bx">
                  {loading ? (
                    <Spin />
                  ) : (
                    <div>
                      <span>Opening Balance</span>
                      <h3>{item?.OpeningBalance}</h3>
                    </div>
                  )}
                  <div className="bx_icon">
                    <img src={gropicons} alt="" />
                  </div>
                </div>
              </div>

              <div className="card_wrap" style={{ backgroundColor: "#009EDB" }}>
                <div className="card_bx">
                  {loading ? (
                    <Spin />
                  ) : (
                    <div>
                      <span>Closing Balance</span>
                      <h3>{item?.ClosingBalance}</h3>
                    </div>
                  )}
                  <div className="bx_icon">
                    <img src={reloadicon} alt="" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Space>

      {/* Wallet Graph */}
      {!loading && state?.items && <WalletGraph data={state} />}
    </Fragment>
  );
};
